import MenuSpy from 'menuspy';

document.querySelectorAll('.article__toc-list').forEach($tableOfContents => new MenuSpy($tableOfContents, {
  menuItemSelector: '.article__toc-link',
  activeClass: 'article__toc-item--active',
  threshold: 50,
  enableLocationHash: false,
}));
